import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getDoc, collection, doc, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons'
const Page = () => {
  const id = useParams();
  const [post, setPost] = useState();

  useEffect(() => {
    getPost()
  }, []);

  const getPost = async() =>{
    const docRef = doc(db, "Posts", id.id);
    const docSnap = await getDoc(docRef);
    setPost(docSnap.data())
  }
  return (
    <div className='dashboard'>
    <div className='title'>
        <h2>CommunityConnect.</h2>
    </div>
    <div class="mainDash" >
        <div class="posts" style={{'display':'flex', "width":"100rem"}}>

    <div class={`post ${post?.post.status}`} style={{'width':'100rem', "justifySelf":"center","height": "30rem"}}>
        <div class="pagePost">
        <div className="details">
          <div class={`status ${post?.post.status=="Fixed" ? "fText" : "uText"}`}>{post?.post.status}</div>
          <h2 style={{'fontSize':'4rem'}}>{post?.post.title}</h2>
          <div class="tags">
            {post?.post.tags.map((tag)=>(
              <div class="tag">{tag}</div>
            ))}
          </div>
          <h4 style={{'fontSize':'1.5rem', 'fontWeight':'400'}}><span style={{'fontWeight':'bold'}}>Description:</span> {post?.post.caption}</h4>
        </div>
        <div class="rating" style={{'backgroundColor':'white'}}>
          <FontAwesomeIcon className="thumbs" icon={faThumbsUp} />
          <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            {post?.post.up - post?.post.down}
          </div>
          <FontAwesomeIcon className="thumbs" icon={faThumbsDown} />
        </div>
      </div>
      
        </div>
        </div>
    </div>
    <div class="chats">
    <span style={{'fontSize':'2rem', 'marginTop':'2rem', 'marginLeft':'4rem'}}>Comments</span>
        <div class="comment">
            <h4>John Doe</h4>
            <h5>This project is wack</h5>
            <h1 class="time">9:40pm</h1>
        </div>

    </div>
</div>
  );
};

export default Page;
